import { useLanguage } from "../../context/LanguageContext";
import { WHATSAPP_URL, EMAIL, PHONE_DISPLAY } from "../../i18n/content";

export const Footer = () => {
  const { t } = useLanguage();

  const scrollToId = (id) =>
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <footer data-testid="site-footer" className="bg-brand-ink text-brand-paper">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 pt-20 md:pt-28 pb-10">
        <div className="grid lg:grid-cols-12 gap-14 pb-16 md:pb-24 border-b border-white/10">
          <div className="lg:col-span-6">
            <div className="font-cabinet font-black tracking-tight leading-none text-6xl md:text-8xl select-none">
              <span className="text-white">D</span>
              <span className="text-brand-red">D</span>
              <span className="text-brand-green">G</span>
            </div>
            <p className="mt-6 max-w-sm text-sm md:text-base leading-relaxed text-white/55">
              {t.footer.tagline}
            </p>
          </div>

          <div className="lg:col-span-2">
            <p className="text-xs font-bold tracking-[0.2em] uppercase text-white/40 mb-6">
              {t.footer.navTitle}
            </p>
            <ul className="flex flex-col gap-3.5">
              {[
                { id: "manifesto", label: t.nav.about, testid: "footer-nav-manifesto" },
                { id: "services", label: t.nav.services, testid: "footer-nav-services" },
                { id: "contact", label: t.nav.contact, testid: "footer-nav-contact" },
              ].map((l) => (
                <li key={l.id}>
                  <button
                    data-testid={l.testid}
                    onClick={() => scrollToId(l.id)}
                    className="text-sm text-white/65 hover:text-white transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-brand-green"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
              <li>
                <a
                  data-testid="footer-nav-articles"
                  href="/artikel"
                  className="text-sm text-white/65 hover:text-white transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-brand-green"
                >
                  {t.nav.articles}
                </a>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <p className="text-xs font-bold tracking-[0.2em] uppercase text-white/40 mb-6">
              {t.footer.servicesTitle}
            </p>
            <ul className="flex flex-col gap-3.5">
              {t.services.items.slice(0, 5).map((s) => (
                <li key={s.id}>
                  <a
                    data-testid={`footer-service-${s.id}`}
                    href={`/layanan/${s.id}`}
                    className="text-sm text-white/65 hover:text-white transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-brand-green"
                  >
                    {s.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <p className="text-xs font-bold tracking-[0.2em] uppercase text-white/40 mb-6">
              {t.footer.contactTitle}
            </p>
            <ul className="flex flex-col gap-3.5 text-sm text-white/65">
              <li>
                <a data-testid="footer-email-link" href={`mailto:${EMAIL}`} className="hover:text-white transition-colors duration-300 break-all focus:outline-none focus:ring-2 focus:ring-brand-green">
                  {EMAIL}
                </a>
              </li>
              <li>
                <a data-testid="footer-whatsapp-link" href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-brand-green">
                  {PHONE_DISPLAY}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p data-testid="footer-rights" className="text-xs text-white/40 tracking-wide">
            {t.footer.rights}
          </p>
          <a
            data-testid="footer-admin-link"
            href="/admin"
            className="text-xs text-white/30 hover:text-white/70 transition-colors duration-300 tracking-wide focus:outline-none focus:ring-2 focus:ring-brand-green"
          >
            {t.footer.adminLink}
          </a>
        </div>
      </div>
    </footer>
  );
};
